import * as firebase from "firebase";

const config = {
	apiKey: "AIzaSyBXfo2janxgdu2u4yk--vhg5GUzTQKgr6o",
	authDomain: "rfc-hot-spots-app.firebaseapp.com",
	databaseURL: "https://rfc-hot-spots-app.firebaseio.com",
	projectId: "rfc-hot-spots-app",
	storageBucket: "rfc-hot-spots-app.appspot.com",
	messagingSenderId: "861986756329",
	appId: "1:861986756329:web:40982ff6d8ef084081c278",
	measurementId: "G-ESJ0G23RBW",
};
firebase.initializeApp(config);

export default firebase;
